module.exports = __webpack_public_path__ + "static/tp-feature-4-ad31a21af727d3551ffbd4ee2c6edc39.png";